import { OnInit } from '@angular/core';
import { PeriodoReporte } from 'src/app/model/administrador';
import { Reportes } from 'src/app/model/reporte';
import { frmReporte } from 'src/app/model/formularios';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { Roles } from 'src/app/model';
export class CustomAdapter extends NgbDateAdapter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    fromModel(value) {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[2], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[0], 10)
            };
        }
        return null;
    }
    toModel(date) {
        return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : null;
    }
}
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    parse(value) {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[2], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[0], 10)
            };
        }
        return null;
    }
    format(date) {
        return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : '';
    }
}
export class ParametrosComponent {
    constructor(_admin, excelService, ngbCalendar, dateAdapter, catalogosService, configuracionService, userService) {
        this._admin = _admin;
        this.excelService = excelService;
        this.ngbCalendar = ngbCalendar;
        this.dateAdapter = dateAdapter;
        this.catalogosService = catalogosService;
        this.configuracionService = configuracionService;
        this.userService = userService;
        this.model = new frmReporte;
        this.rango = { start: null, end: null };
        this.datePipe = new DatePipe('es-MX');
        this.ejercicio = null;
        this.ejercicios = [];
        //Fechas Minimo Maximo
        this.mindate = moment().subtract(1, 'years');
        this.maxdate = moment();
        this.minAnio = 0;
        this.minMes = 0;
        this.minDia = 0;
        this.minAnio2 = 0;
        this.minMes2 = 0;
        this.minDia2 = 0;
        this.maxAnio = 0;
        this.maxMes = 0;
        this.maxDia = 0;
        this.roles = Roles;
        moment.locale('es');
        this.minAnio = this.mindate.year();
        this.minMes = this.mindate.month() + 1;
        this.minDia = this.mindate.date();
        this.minAnio2 = this.mindate.year();
        this.minMes2 = this.mindate.month() + 1;
        this.minDia2 = this.mindate.date();
        this.maxAnio = this.maxdate.year();
        this.maxMes = this.maxdate.month() + 1;
        this.maxDia = this.maxdate.date();
    }
    ngOnInit() {
        this.userInfo$ = this.userService.userInfo$;
        this.catalogosService.CatalogoEjercicios().subscribe((result) => {
            this.ejercicios = result.map(num => ({ label: num.toString(), value: num }));
            if (!this.configuracionService.getDatos().ejercicio) {
                this.ejercicio = result[0] ? result[0] : this.maxdate.year();
                this.configuracionService.actualizar({ ejercicio: this.ejercicio });
            }
            else {
                this.ejercicio = this.configuracionService.getDatos().ejercicio;
            }
        });
        if (!this.configuracionService.getDatos().esProcesoElectoral) {
            this.catalogosService.EsProceso().subscribe((result) => {
                this.esProceso = result.esProceso;
                this.configuracionService.actualizar({ esProcesoElectoral: this.esProceso });
            });
        }
        else {
            this.esProceso = this.configuracionService.getDatos().esProcesoElectoral;
        }
    }
    get today() {
        return this.dateAdapter.toModel(this.ngbCalendar.getToday());
    }
    onSelect(date) {
        let toDate = this.model.fechaFin.split('/');
        let toDateStruct = {
            day: parseInt(toDate[2], 10),
            month: parseInt(toDate[1], 10),
            year: parseInt(toDate[0], 10)
        };
        if (date.after(toDateStruct))
            this.model.fechaFin = '';
        this.minAnio2 = date.year;
        this.minMes2 = date.month;
        this.minDia2 = date.day;
    }
    generarReporte() {
        let periodo = new PeriodoReporte();
        periodo.desde = this.model.fechaInicio;
        periodo.hasta = this.model.fechaFin;
        this._admin.obtenerReportes(JSON.stringify(periodo)).subscribe((result) => {
            let arreglo = [];
            if (result.length > 0)
                for (let a = 0; a < result.length; a++) {
                    let e = result[a];
                    let reporte = new Reportes();
                    reporte.idSolicitud = e.idSolicitud;
                    reporte.procesoElectoral = e.esProceso;
                    reporte.organo = e.organo;
                    reporte.usuarioDiligencia = (e.usuarioDiligencia == null) ? '' : e.usuarioDiligencia + ' ' + e.usuarioDiligenciaPuesto;
                    reporte.recepcion = e.recepcion;
                    reporte.noPeticion = e.noPeticion;
                    reporte.fechaRecepcion = this.datePipe.transform(e.fechaRecepcion, 'dd/MM/yyyy HH:mm');
                    reporte.peticionario = e.peticionario;
                    reporte.partido = (e.partido == null ? e.unidadResponsable : e.partido);
                    reporte.procedimientoSancionador = e.procedimientoSancionador;
                    reporte.hechosDenunciados = e.hechosDenunciados;
                    reporte.acto = e.acto;
                    for (let i = 0; i < e.Ubicaciones.length; i++) {
                        let u = e.Ubicaciones[i];
                        reporte.ubicacion += 'Calle: ' + u.calle + ', Colonia: ' + (u.colonia == null ? '' : u.colonia) + ', C.P.: ' + (u.cp == null ? '' : u.cp) + ', Municipio: ' + u.municipio + ' | ';
                    }
                    ;
                    reporte.cumpleRequisistos = e.cumpleRequisistos;
                    reporte.existePrevencion = e.existePrevencion;
                    for (let i = 0; i < e.Prevenciones.length; i++) {
                        let p = e.Prevenciones[i];
                        reporte.prevenciones += p.descripcion + ' | ';
                    }
                    ;
                    reporte.fechaPrevencion = this.datePipe.transform(e.fechaPrevencion, 'dd/MM/yyyy HH:mm');
                    reporte.fechaRespuesta = this.datePipe.transform(e.fechaRespuesta, 'dd/MM/yyyy HH:mm');
                    reporte.atiendePrevencion = e.existeRespuesta;
                    reporte.fechaInicioDiligencia = this.datePipe.transform(e.fechaInicioDiligencia, 'dd/MM/yyyy HH:mm');
                    reporte.fechaFinDiligencia = this.datePipe.transform(e.fechaFinDiligencia, 'dd/MM/yyyy HH:mm');
                    reporte.acta = e.acta;
                    reporte.fechaInicioActa = this.datePipe.transform(e.fechaInicioActa, 'dd/MM/yyyy HH:mm');
                    reporte.fechaFinActa = this.datePipe.transform(e.fechaFinActa, 'dd/MM/yyyy HH:mm');
                    reporte.folios = e.folios;
                    for (let i = 0; i < e.Copias.length; i++) {
                        let c = e.Copias[i];
                        reporte.copiasCertificadas += c.folio + ' | ';
                        reporte.fechaExpedida += this.datePipe.transform(c.fechaExpedida, 'dd/MM/yyyy') + ' | ';
                        reporte.fechaEntrega += this.datePipe.transform(c.fechaHoraEntrega, 'dd/MM/yyyy HH:mm') + ' | ';
                        reporte.fechaDigitalizacion += this.datePipe.transform(c.fechaHoraRegistro, 'dd/MM/yyyy HH:mm') + ' | ';
                    }
                    ;
                    reporte.fechaImporcedencia = this.datePipe.transform(e.fechaImporcedencia, 'dd/MM/yyyy HH:mm');
                    arreglo.push(reporte);
                }
            ;
            this.excelService.exportAsExcelFile(arreglo, 'reporte');
        });
    }
    btnChangeEstatus(estatus) {
        this._admin.accionCambioProceso(estatus.srcElement.checked).subscribe(r => { });
        this.configuracionService.actualizar({ esProcesoElectoral: estatus.srcElement.checked });
    }
    actualizarEjercicio() {
        this.configuracionService.actualizar({ ejercicio: this.ejercicio });
    }
}
